<template>
	<div class="cjt-container">
		<div class="cjt-head">
			<!-- 顶部导航栏 -->
			<top-nav-head></top-nav-head>
		</div>

		<div class="cjt-main">
			<div class="user-container">
				<!-- 左侧导航 -->
				<div class="user-sidebar">
					<el-menu :default-active="activeMenu" :default-openeds="defaultOpeneds" router>
						<el-menu-item index="/user/profile">
							<svg-icon icon-class="IDcard"></svg-icon>
							<span>个人资料</span>
						</el-menu-item>

						<el-menu-item index="/user/message">
							<svg-icon icon-class="noticeFill"></svg-icon>
							<span>消息通知</span>
						</el-menu-item>

						<el-submenu index="monitor">
							<template #title>
								<svg-icon icon-class="monitored" class="icon" />
								<span>监控预警</span>
							</template>
							<el-menu-item index="/user/monitor/list">监控列表</el-menu-item>
							<el-menu-item index="/user/monitor/message-settings">监控消息设置</el-menu-item>
							<el-menu-item index="/user/monitor/settings">监控设置</el-menu-item>
						</el-submenu>

						<el-submenu index="common">
							<template #title>
								<svg-icon icon-class="manage" class="icon" />
								<span>常用功能</span>
							</template>
							<el-menu-item index="/user/common/export">导出记录</el-menu-item>
							<el-menu-item index="/user/common/company">我的企业</el-menu-item>
							<el-menu-item index="/user/common/collection">我的收藏</el-menu-item>
							<!-- <el-menu-item index="/user/common/subscription">我的订阅</el-menu-item> -->
						</el-submenu>

						<el-submenu index="market">
							<template #title>
								<svg-icon icon-class="shoppingCart" class="icon" />
								<span>会员管理</span>
							</template>
							<el-menu-item index="/user/market/order">会员订单</el-menu-item>
							<el-menu-item index="/user/market/invoice">我的发票</el-menu-item>
							<!-- <el-menu-item index="/user/market/coupon">我的优惠券</el-menu-item> -->
							<el-menu-item index="/user/market/my-member-benefits">会员权益</el-menu-item>
							<el-menu-item index="/user/market/my-member-benefits-record">会员权益使用记录</el-menu-item>
						</el-submenu>

						<el-submenu index="shoppmanag">
							<template #title>
								<svg-icon icon-class="shoppingCart" class="icon" />
								<span>购物管理</span>
							</template>
							<el-menu-item index="/user/shoppmanag/shoppOrder">购物订单</el-menu-item>
							<!-- <el-menu-item index="/user/shoppmanag/shoppOrderSelect">购物车</el-menu-item> -->
						</el-submenu>
					</el-menu>
				</div>
				<!-- 右侧内容区域 -->
				<div class="user-content">
					<router-view></router-view>
				</div>
			</div>
		</div>

		<!-- 页脚 -->
		<page-footer></page-footer>
	</div>
</template>

<script>
	import TopNavHead from '@/components/TopNavHead'
	import PageFooter from '@/components/PageFooter'

	export default {
		name: 'User',
		components: {
			TopNavHead,
			PageFooter
		},
		props: {},
		data() {
			return {
				defaultOpeneds: ['monitor', 'common', 'market']
			}
		},
		computed: {
			activeMenu() {
				const path = this.$route.path

				// 定义子路由与父路由的映射关系
				const menuMap = {
					'/user/common/company/': '/user/common/company',
					'/user/common/export/': '/user/common/export',
					'/user/common/collection/': '/user/common/collection',
					'/user/common/subscription/': '/user/common/subscription',
					'/monitor/list': '/user/common/monitor',
					'/user/monitor/message-settings': '/user/monitor/message-settings',
					'/user/monitor/settings': '/user/monitor/settings',
					'/user/market/order/': '/user/market/order',
					'/user/market/invoice/': '/user/market/invoice'
				}

				// 查找当前路径是否匹配任何子路由前缀
				for (const prefix in menuMap) {
					if (path.startsWith(prefix) && path !== prefix.slice(0, -1)) {
						return menuMap[prefix]
					}
				}

				return path
			}
		},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	.cjt-container {
		min-height: 100vh;

		.cjt-main {
			display: flex;
			height: calc(100vh - #{$top-bar-height} - 100px);
			background-image: url('~@/assets/user/user-page-bg.jpg');
			background-repeat: no-repeat;
			background-position: center;
		}

		.user-container {
			display: flex;
			width: $main-page-width;
			// height: 100%;
			margin: 0 auto;
			padding: 20px 0;

			.user-sidebar {
				// width: 217px;
				flex: 0 0 217px;
				background-color: #ffffff;
				border-radius: 6px;
				overflow: hidden;
				overflow-y: auto;

				::v-deep .el-menu {
					border: none;

					.el-menu-item,
					.el-submenu .el-submenu__title {
						height: 48px;
						line-height: 48px;
						font-size: 16px;
						font-weight: bold;
						color: #333333;

						&:hover {
							color: #ffffff;
							background-color: #236fca;

							i {
								color: #ffffff;
							}
						}
						&.is-active {
							color: #ffffff;
							background-color: #236fca;
						}

						&:hover .svg-icon,
						&.is-active .svg-icon {
							color: #ffffff;
						}

						i {
							color: #979797;
						}
					}

					.el-submenu .el-menu-item {
						padding-left: 49px !important;
						font-weight: 500;
					}

					.el-submenu .svg-icon,
					.el-menu-item .svg-icon {
						margin-right: 5px;
						width: 24px;
						text-align: center;
						font-size: 22px;
						vertical-align: middle;
						color: #979797;
					}

					.el-submenu .el-menu {
						background-color: #f5f9fa;
					}
				}
			}

			.user-content {
				flex: 1;
				margin-left: 20px;
				overflow: hidden; // 防止内容溢出
				max-width: calc(100% - 237px); // 217px侧边栏宽度 + 20px左边距
			}
		}
	}
</style>
